export default __webpack_public_path__ + "static/media/bgTalocMayan.a5b58804.jpg";